import React from 'react'
import MenuTagInPutBase from './MenuTagInPutBase';

export default function MenuTagInputNotAuthen(props) {
  // common projectInuse state
  const projectDetail = {};
  const isProjectManager = false;
  const userListOfProject = [];

  return (
      <MenuTagInPutBase
          {...props}
          projectDetail={projectDetail}
          isProjectManager={isProjectManager}
          userListOfProject={userListOfProject}
          formsInCorporation={[]}
          fieldsInCorporation={[]}
      />
  );
}
